import { DOCUMENT_IDS } from 'components/Patient/checkin/SecurePayment/components/CheckinSuccess/lib/constants';

export const PRE_AUTH_DOCUMENT_ID = 'pre-auth-form';
export const PATIENT_FORMS_DOCUMENT_ID = 'patient-forms';
export const PATIENT_OPTION_LETTER_DOCUMENT_ID = 'patient-option-letter';
export const SECURE_PAYMENT_DOCUMENT_ID = 'secure-payment';
export const INSURANCE_DOCUMENT_ID = 'insurance-eligibility';
export const GOOD_FAITH_ESTIMATE_DOCUMENT_ID = 'good-faith-estimate';
export const CLEAR_CARE_DOCUMENT_ID = 'clear-care-guide';

export const SECURE_PAYMENT_DOCUMENT = { id: SECURE_PAYMENT_DOCUMENT_ID, name: 'Secure payment' };

// Shape matches CheckinSuccess DOCUMENTS so DocumentPicker/useDocumentSelection can be reused.
export const PATIENT_DOCUMENTS = [
  {
    id: INSURANCE_DOCUMENT_ID,
    name: 'New/updated insurance + eligibility',
    icon: 'payers-filled'
  },
  { id: GOOD_FAITH_ESTIMATE_DOCUMENT_ID, name: 'Good Faith Estimate', icon: 'shield-tick-filled' },
  {
    id: PATIENT_OPTION_LETTER_DOCUMENT_ID,
    name: 'Patient Option Letter',
    icon: 'receipt-1-filled'
  },
  { id: PRE_AUTH_DOCUMENT_ID, name: 'Pre-auth form', icon: 'lock-2-filled' },
  { id: CLEAR_CARE_DOCUMENT_ID, name: 'Dr.ClearCare full guide', icon: 'ai-summary-filled' },
  { id: PATIENT_FORMS_DOCUMENT_ID, name: 'Patient forms', icon: 'note-filled' }
];

// Always sent with a payment, so they are neither listed nor togglable in the picker.
export const MANDATORY_PATIENT_DOCUMENT_IDS = [
  GOOD_FAITH_ESTIMATE_DOCUMENT_ID,
  PATIENT_OPTION_LETTER_DOCUMENT_ID,
  CLEAR_CARE_DOCUMENT_ID
];

export const OPTIONAL_PATIENT_DOCUMENTS = PATIENT_DOCUMENTS.filter(
  (document) => !MANDATORY_PATIENT_DOCUMENT_IDS.includes(document.id)
);

const PREVIEWABLE_DOCUMENT_IDS = [
  SECURE_PAYMENT_DOCUMENT_ID,
  INSURANCE_DOCUMENT_ID,
  PRE_AUTH_DOCUMENT_ID,
  PATIENT_FORMS_DOCUMENT_ID
];

export const DOCUMENT_PREVIEW_TITLES = Object.fromEntries(
  [SECURE_PAYMENT_DOCUMENT, ...PATIENT_DOCUMENTS]
    .filter(({ id }) => PREVIEWABLE_DOCUMENT_IDS.includes(id))
    .map(({ id, name }) => [id, name])
);

export const hasDocumentPreview = (id) => !!DOCUMENT_PREVIEW_TITLES[id];

export const APPOINTMENT_DOCUMENT_PREVIEW_IDS = {
  [CLEAR_CARE_DOCUMENT_ID]: DOCUMENT_IDS.DR_CLEAR_CARE
};

export const SECURE_PAYMENT_LETTER_DOCUMENT_IDS = [
  GOOD_FAITH_ESTIMATE_DOCUMENT_ID,
  PATIENT_OPTION_LETTER_DOCUMENT_ID
];
